<template>
  <div>
    <div class="box" id="box" ref="box">
      <div class="title-box">
        <div class="title-logo"></div>
        <div class="title-txt">知识图谱本体结构</div>
      </div>

      <topo></topo>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {

  }
};


</script>
<style scoped  lang="less">
.box {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 551px;
  height: 620px;
  left: 250px;
  border-radius: 10px;
  position: relative;
}
.title-box {
  .title-logo {
    background-image: url("../../assets/img/ask_logo.png");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 53px;
    width: 59px;
    position: absolute;
    left: 20px;
    top: 15px;
  }
  .title-txt {
    background-image: url("../../assets/img/ask_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    font-size: 24px;
    height: 54px;
    width: 260px;
    line-height: 54px;
    position: absolute;
    left: 79px;
    top: 15px;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
    text-align: left;
    padding-left: 20px;
  }
}
.warp {
  position: absolute;
  left: 18px;
  top: 58px;
  height: 335px;
  font-family: AlibabaRegular;
  overflow: hidden;
}


</style>
